import styled from 'styled-components';
import { Modal } from 'components/ui';

export const StyledModal = styled(Modal)`
  .ant-modal-body {
    max-height: 500px;
    overflow: scroll;
  }
`;

export const SpinContainer = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
